import { render } from "./FAQ.vue?vue&type=template&id=eebac7b0"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=eebac7b0&rel=stylesheet&lang=scss"
script.render = render

export default script